import { FC } from "react";
import { BucketFile, FileExtensionType } from "types";
import style from "./style.module.scss";

export type ExtensionFileIconProps = Pick<BucketFile, "fileExtensionType">;

export const ExtensionFileIcon: FC<ExtensionFileIconProps> = ({
  fileExtensionType,
}) => {
  const getIcon = (fileExtensionType: FileExtensionType) => {
    switch (fileExtensionType) {
      case "image":
        return "bi-file-image";
      case "excel":
        return "bi-file-earmark-excel";
      case "pdf":
        return "bi-file-earmark-pdf";
      case "calc":
        return "bi-file-earmark-spreadsheet";
      case "text":
        return "bi-file-earmark-text";
      case "word":
        return "bi-file-earmark-word";
      default:
      case "document":
        return "bi-file-earmark";
    }
  };

  const icon = getIcon(fileExtensionType);

  return (
    <i
      className={`bi ${icon} ${style["extension"]} ${
        style[`extension-${fileExtensionType}`]
      }`}
    />
  );
};
